export class GoogleWorkspaceUserDriveSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<SaasRestoreItem>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "SaasRestoreMode",
            "format": ""
        },
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveFolderHierarchy",
            "baseName": "preserveFolderHierarchy",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetDrive",
            "baseName": "targetDrive",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserDriveSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
